import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { FileService } from '../../../core/service/file.service';
import { MessageService } from '../../../core/service/message.service';
import { AmortizationPlan, AmortizationPlanDocument } from '../../model/amortization-plan';
import { AmortizationPlanDocumentService } from '../../service/data/amortization-plan-document.service';

@Component({
  standalone: false,
  selector: 'app-amortization-plan-document-form',
  templateUrl: './amortization-plan-document-form.component.html',
})
export class AmortizationPlanDocumentFormComponent implements OnDestroy, OnInit {
  private _subscription = new Subscription();

  dataContext: AmortizationPlan;
  form: FormGroup;

  constructor(
    private readonly _actionService: ActionWindowService,
    private readonly _dataService: AmortizationPlanDocumentService,
    private readonly _fb: FormBuilder,
    private readonly _fcf: FormControlExFactory,
    private readonly _fileService: FileService,
    private readonly _messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.form = this._fb.group({
      caption: this._fcf.createMandatory('LEASE_AGREEMENT_DOCUMENT.CAPTION', ''),
      document: this._fcf.createMandatory('', null),
      amortizationPlan: this._fcf.createHidden(this.dataContext?.id),
    });
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  cancel(): void {
    this._actionService.close();
  }

  onFileChange(files: FileList): void {
    if (!files || files.length !== 1) {
      this.form.controls['document'].reset();
      this.form.controls['caption'].reset();
      return;
    }

    const file = files.item(0);
    const error = this._fileService.validateDocument(file);
    if (error) {
      this.form.controls['document'].reset();
      this.form.controls['caption'].reset();
      this._messageService.showError(error);
      return;
    }

    this.form.controls['document'].setValue(file);
    const dotIndex = file.name.lastIndexOf('.');
    this.form.controls['caption'].setValue(dotIndex > 0 ? file.name.substring(0, dotIndex) : file.name);
  }

  onSubmit(): void {
    if (!this.form.valid) {
      return;
    }

    this._subscription.add(
      this._dataService
        .add(Object.assign(new AmortizationPlanDocument(), this.form.value))
        .subscribe(() => this._actionService.complete(true))
    );
  }
}
